import { all } from "redux-saga/effects";
import watchAddScenarioListAsync, {
  watchAddScenarioTotalsAsync,
  watchAddScenarioList,
  watchChangeSelectedScenarioAsync,
  watchDeleteScenarioTotalsAsync,
} from "app/scenarios/duck/saga";
import watchAddCycleListAsync from "app/common/cycle/duck/saga";
import watchAddCategoriesListAsync, {
  watchAddLinesListAsync,
  watchAddProductsListAsync,
} from "app/common/catalog/duck/saga";
import watchAddAreasListAsync from "app/common/area/duck/saga";
import watchAddRetailersListAsync from "app/common/retailer/duck/saga";
import watchSetMetadataAsync from "app/common/metadata/duck/saga";

export default function* rootSaga() {
  yield all([
    watchAddScenarioListAsync(),
    watchAddCycleListAsync(),
    watchSetMetadataAsync(),
    watchAddCategoriesListAsync(),
    watchAddLinesListAsync(),
    watchAddRetailersListAsync(),
    watchAddAreasListAsync(),
    watchChangeSelectedScenarioAsync(),
    watchAddProductsListAsync(),
    watchAddScenarioTotalsAsync(),
    watchAddScenarioList(),
    watchDeleteScenarioTotalsAsync(),
  ]);
}
